import {useEffect} from "react"
import {useSignal} from "@preact/signals-react"
import {getSubmit} from "@ui-seeker/utils"

import {BACKEND_APIS} from "@constants"


export default function useUsers() {
	const users = useSignal([])
	const isLoading = useSignal(true)

	useEffect(() => {
		getSubmit(`${BACKEND_APIS.BATCH_ADMIN}/users`)
			.then(res => {
				users.value = res || []
			})
			.catch(err => {
				console.error('Failed to fetch users:', err)
				users.value = []
			})
			.finally(() => {
				isLoading.value = false
			})
	}, [])

	return {
		users: users.value,
		isLoading: isLoading.value
	}
}
